export default __webpack_public_path__ + "static/favicon-4dcc92ba9d3bbdb7f433bc484b3c7274.ico";